// Kitchen coordinates (Nagpur)
export const KITCHEN_COORDINATES = {
  lat: 21.1268,
  lng: 79.0550,
};

// Maximum serviceable radius in kilometers
export const MAX_SERVICE_RADIUS_KM = 10;

// Road distance multiplier to convert straight-line distance to approximate road distance
// Typical urban areas have a road distance factor of 1.2-1.3x the straight-line distance
export const ROAD_DISTANCE_MULTIPLIER = 1.25;

/**
 * Calculate distance between two coordinates using Haversine formula
 * @param {number} lat1 - Latitude of first point
 * @param {number} lon1 - Longitude of first point
 * @param {number} lat2 - Latitude of second point
 * @param {number} lon2 - Longitude of second point
 * @returns {number} Distance in kilometers
 */
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  // Using WGS84 equatorial radius for better accuracy matching Google Maps
  const R = 6378.137; // Radius of the Earth in kilometers
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  
  return distance;
};

/**
 * Convert degrees to radians
 * @param {number} deg - Degrees
 * @returns {number} Radians
 */
const toRad = (deg) => {
  return deg * (Math.PI / 180);
};

/**
 * Check if a location is within serviceable area
 * @param {number} lat - User's latitude
 * @param {number} lng - User's longitude
 * @returns {object} { isServiceable: boolean, distance: number }
 */
export const isLocationServiceable = (lat, lng) => {
  // Calculate straight-line distance
  const straightLineDistance = calculateDistance(
    KITCHEN_COORDINATES.lat,
    KITCHEN_COORDINATES.lng,
    lat,
    lng
  );

  // Apply road distance multiplier to get approximate road distance
  const roadDistance = straightLineDistance * ROAD_DISTANCE_MULTIPLIER;
  
  return {
    isServiceable: roadDistance <= MAX_SERVICE_RADIUS_KM,
    distance: parseFloat(roadDistance.toFixed(2)),
  };
};
